import { Box, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';

function PhoneInputField({
  value,
  error,
  handleChange,
  // countryCode, handleCountryCode
  ...props
}) {
  // == Handle Error Text based on value ==
  const phoneErrorMessage = () => {
    if (error && !value.length) return 'Phone Number is required';
    if (error && value.length >= 1 && value.length < 10) return 'Please add a valid number';
    return error && value.length === 10 && '';
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex' }}>
        <TextField
          label="Phone Number"
          placeholder="9999999999"
          fullWidth
          value={value}
          InputProps={{
            startAdornment: <InputAdornment position="start">+91</InputAdornment>,
            maxLength: 10
          }}
          type="number"
          onChange={(e) => {
            // eslint-disable-next-line
            handleChange(Math.max(0, parseInt(e.target.value)).toString().slice(0, 10))
          }}
          {...props}
        />
      </Box>
      {error && (
        <div style={{ color: '#ff4842', fontSize: '12px', marginLeft: '14px', marginTop: '3px' }}>
          {phoneErrorMessage()}
        </div>
      )}
    </Box>
  );
}

PhoneInputField.propTypes = {
  value: PropTypes.string,
  error: PropTypes.bool,
  // countryCode: PropTypes.string,
  handleChange: PropTypes.func
  // handleCountryCode: PropTypes.func
};

export default PhoneInputField;
